"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoInfoMonitor = void 0;

var _getProperty = require("../../util/getProperty");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_UPDATE_OPTS = {
  loopCount: true,
  paused: true,
  duration: true,
  currentTime: {
    type: "number",
    minChange: 1
  },
  gameTime: false,
  progress: false,
  active: true,
  video_id: false,
  moment: {
    type: "number",
    path: "game_clip_id"
  },
  sourceCount: true,
  readyState: true,
  multicamOpen: true,
  fullscreen: true,
  camera: true,
  network_speed: true,
  loading_mode: true,
  scrubber: [{
    type: "number",
    path: "currentTime",
    minChange: 1
  }, {
    type: "number",
    path: "duration",
    minChange: 1
  }],
  insideMoment: true,
  fluid: false,
  currentMoment: {
    type: "number",
    path: "game_clip_id"
  }
};

var VideoInfoMonitor = /*#__PURE__*/function () {
  function VideoInfoMonitor(containerRef, onChange) {
    var _this = this;

    var updateOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var debugName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, VideoInfoMonitor);

    _defineProperty(this, "_onVideoInfoUpdate", function (event) {
      if (event && event.detail) {
        if ("video-player-".concat(_this.containerRef.current) === event.detail.video_id) {
          _this.info = event.detail;
        }
      }
    });

    this.containerRef = containerRef;
    this.opts = updateOpts ? updateOpts : DEFAULT_UPDATE_OPTS;
    this._info = {};
    this._onChange = onChange;
    this._onVideoInfoUpdate = this._onVideoInfoUpdate.bind(this);

    this._addListener();
  }

  _createClass(VideoInfoMonitor, [{
    key: "destroy",
    value: function destroy() {
      this._removeListener();

      this._onChange = null;
      this._info = null;
      this._opts = null;
    }
  }, {
    key: "info",
    get: function get() {
      return this._info;
    },
    set: function set(info) {
      var prevInfo = this._info;
      var significantChange = false;

      for (var key in this.opts) {
        var opt = this.opts[key];
        var val = info[key];
        var prevVal = prevInfo[key];

        if (opt === true) {
          // strict equality check
          if (val !== prevVal) {
            significantChange = true;
          }
        } else if (opt) {
          var optArray = Array.isArray(opt) ? opt : [opt];

          for (var i = 0; i < optArray.length; i++) {
            var subOpt = optArray[i];
            var subVal = val;
            var subPrevVal = prevVal;

            if (subOpt.path) {
              subVal = (0, _getProperty.getProperty)(subOpt.path ? subOpt.path : key, val, null);
              subPrevVal = (0, _getProperty.getProperty)(subOpt.path ? subOpt.path : key, prevVal, null);
            }

            if (subOpt.type === "number") {
              if (typeof subPrevVal !== "number" && typeof subVal !== "number") {
                // both are not expected type, so no change
                continue;
              } else if (!subVal || !subPrevVal) {
                // one is null, so change
                significantChange = true;
                break;
              }

              var minChange = subOpt.minChange || false;

              if (minChange) {
                if (Math.abs(subVal - subPrevVal) >= minChange) {
                  significantChange = true;
                  break;
                }
              } else {
                if (subVal !== subPrevVal) {
                  significantChange = true;
                  break;
                }
              }

              if (Math.abs(subVal - subPrevVal) > (subOpt.minChange ? subOpt.minChange : 0)) {
                significantChange = true;
                break;
              }
            } else {
              if (subVal !== subPrevVal) {
                significantChange = true;
                break;
              }
            }
          }
        }

        if (significantChange) {
          break;
        }
      }

      if (significantChange) {
        this._info = info;

        if (typeof this._onChange === "function") {
          this._onChange(info);
        }
      }
    }
  }, {
    key: "_addListener",
    value: function _addListener() {
      document.addEventListener("trc-video-info", this._onVideoInfoUpdate);
    }
  }, {
    key: "_removeListener",
    value: function _removeListener() {
      document.removeEventListener("trc-video-info", this._onVideoInfoUpdate);
    }
  }]);

  return VideoInfoMonitor;
}();

exports.VideoInfoMonitor = VideoInfoMonitor;